<ion-header><app-navheader></app-navheader></ion-header>
<ion-content [ngClass]="themeClass">
<ion-list class="list">
  <ion-item lines="none" class="ion-no-padding" *ngIf="hasCkidAccess" (click)="filterArticles('ckid')">
    <ion-icon slot="start" class="ion-text-center conferences"></ion-icon>
    <ion-label>Les Conférences</ion-label>
  </ion-item>
  <ion-item lines="none" class="ion-no-padding" *ngIf="platformType === 0" (click)="goToExternalArchives()">
    <ion-icon slot="start" class=" ion-text-center star"></ion-icon>
    <ion-label>Archives</ion-label>
  </ion-item>
  <ion-item lines="none" class="ion-no-padding" *ngIf = "themeClass !== 'mquovideo' && themeClass !== 'actuvideo' && themeClass !== 'mwjp' && themeClass !== 'mwde' && themeClass !== 'clfy' && themeClass !== 'mljp' && themeClass !== 'mlde' " (click)="goToFavoris()">
    <ion-icon slot="start" class="favoris ion-text-center"></ion-icon>
    <ion-label>Favoris</ion-label>
  </ion-item>
  <ion-item lines="none" class="ion-no-padding" *ngIf = "platformType === 0 " (click)="goToConcours()">
    <ion-icon slot="start" class="filing ion-text-center"></ion-icon>
    <ion-label>Concours</ion-label>
  </ion-item>
  <ion-item lines="none" class="ion-no-padding" (click)="filterCategory('lepq', 'podcast-lepq')"
    *ngIf = "(themeClass === 'playbacpresse' || themeClass === 'lepq')  && (auth.hasAccessTo() || auth.hasAccessToPdf() || auth.hasAccessToMain())">
    <ion-icon slot="start" class="ion-icon-2 podcast ion-text-center"></ion-icon>
    <ion-label>Podcasts</ion-label>
  </ion-item>
  <ion-item lines="none" class="ion-no-padding" *ngIf = "platformType === 0   && (auth.hasAccessTo() || auth.hasAccessToPdf() || auth.hasAccessToMain())" (click)="filterCategory('play', 'lecons-de-dessin-play')">
    <ion-icon slot="start" class="ion-icon-2 dessin ion-text-center"></ion-icon>
    <ion-label>Leçons de dessin</ion-label>
  </ion-item>
  <ion-item lines="none" class="ion-no-padding" *ngIf = "platformType === 0 && themeClass !== 'actu' && themeClass !== 'aeco' && (!!auth.hasAccessTo() || !!auth.hasAccessToPdf() || !!auth.hasAccessToMain())" (click)="goStaticPage('aide-devoirs')">
    <ion-icon slot="start" class="ion-icon-2 devoir ion-text-center"></ion-icon>
    <ion-label>Aide-devoir</ion-label>
  </ion-item>
  <ion-item lines="none" class="ion-no-padding" [hidden] = "themeClass === 'actuvideo' || themeClass === 'mquovideo' || themeClass === 'sema' || themeClass === 'mlwk' || themeClass === 'week' || themeClass === 'woch' || themeClass === 'mwjp' || themeClass === 'mwde' || themeClass === 'mljp' || themeClass === 'mlde' || themeClass === 'clfy'"
      *ngIf= "!general && (!!auth.hasAccessTo() || !!auth.hasAccessToMain())" (click)="goToThematicFiles(setThematicFilesPage())">
    <ion-icon slot="start" class="dossiers ion-text-center"></ion-icon>
    <ion-label>Dossiers d'actualité</ion-label>
  </ion-item>
  <ion-item lines="none" class="ion-no-padding"  *ngIf="general && theme && (!!auth.hasAccessTo() || !!auth.hasAccessToMain())" (click) ="goToThematicFiles(thematicfilessubcatPage)">
    <ion-icon slot="start" class="dossiers ion-text-center"></ion-icon>
    <ion-label>Dossiers d'actualité</ion-label>
  </ion-item>
  <ion-item lines="none" class="ion-no-padding"  *ngIf="auth.hasAccessToMain() === 'lepq' || auth.hasAccessToMain() === 'mquo' || auth.hasAccessToMain() === 'actu'" (click) ="goToJOThematicFiles()">
    <ion-icon slot="start" class="dossiers ion-text-center"></ion-icon>
    <ion-label>Jeux Olympiques 2024</ion-label>
  </ion-item>
  <ion-item lines="none" class="ion-no-padding" *ngIf="auth.hasAllAccessToNewspaper('aeco') " (click)="filterCategory('aeco', 'une-carriere-a-la-loupe-aeco')">
    <ion-icon slot="start" class="dossiers ion-text-center"></ion-icon>
    <ion-label>Fiches Métiers</ion-label>
  </ion-item>
  <ion-item lines="none" class="ion-no-padding" *ngIf="themeClass === 'mquo' || themeClass === 'lepq' || themeClass === 'actu'" (click)="filterCategoryAuth('numeros-decouvertes-' + themeClass)">
    <ion-icon slot="start" class="dossiers ion-text-center"></ion-icon>
    <ion-label>Numéros Découvertes</ion-label>
  </ion-item>
  <ion-item lines="none" class="ion-no-padding" *ngIf="themeClass === 'mquo' && (auth.hasAccessTo() || auth.hasAccessToPdf() || auth.hasAccessToMain())" (click) = "goToBookOfMonth()">
	  <ion-icon slot="start" class="livredumois ion-text-center"></ion-icon>
    <ion-label>Actu Livres</ion-label>
  </ion-item>
  <ion-item lines="none" class="ion-no-padding" *ngIf="themeClass === 'lepq' && (auth.hasAccessTo() || auth.hasAccessToPdf() || auth.hasAccessToMain())" (click) = "goToBookOfMonth()">
    <ion-icon slot="start" class="livredumois ion-text-center"></ion-icon>
    <ion-label>Actu Livres</ion-label>
  </ion-item>
  <ion-item lines="none" class="ion-no-padding" *ngIf="isAuthenticated && !noEdit && !isChildProfile() " (click)="goToEdit()">
  	<ion-icon slot="start" class="compte ion-text-center"></ion-icon>
    <ion-label>{{ 'MENU.MON_COMPTE' | translate }}</ion-label>
  </ion-item>
  <ion-item lines="none" class="ion-no-padding" *ngIf="isAuthenticated && !noEdit && isChildProfile() " (click)="goToEdit()">
    <ion-icon slot="start" class="compte ion-text-center"></ion-icon>
    <ion-label>{{ 'MENU.MON_PROFIL' | translate }}</ion-label>
  </ion-item>
  <ion-item lines="none" class="ion-no-padding" *ngIf="!isAuthenticated && (themeClass !== 'mquovideo' && themeClass !== 'actuvideo' && themeClass !== 'clfy')" (click)="goToEdit()">
    <ion-icon slot="start" class="compte ion-text-center"></ion-icon>
    <ion-label>{{ 'MENU.SE_CONNECTER' | translate }}</ion-label>
  </ion-item>
  <!-- <ion-item lines="none" class="ion-no-padding" *ngIf = "themeClass !== 'mquovideo' && themeClass !== 'actuvideo' && themeClass !== 'mwjp' && themeClass !== 'mwde' && themeClass !== 'clfy' && themeClass !== 'mljp' && themeClass !== 'mlde' " (click)="goToExternal('https://www3.actito.com/wf/205191/17/fr/Start.act?source=AAA')"> -->
  <ion-item lines="none" class="ion-no-padding" *ngIf = "themeClass !== 'mquovideo' && themeClass !== 'actuvideo' && themeClass !== 'mwjp' && themeClass !== 'mwde' && themeClass !== 'clfy' && themeClass !== 'mljp' && themeClass !== 'mlde' " (click)="goToExternalClub('https://www3.actito.com/wf/205191/17/fr/Start.act?source=AAA')">
 	  <ion-icon slot="start" class="lecteurs ion-text-center"></ion-icon>
    <ion-label>Club des lecteurs</ion-label>
  </ion-item>
  <ion-item lines="none" class="ion-no-padding" *ngIf="isAuthenticated && isTeacherProfile()" (click)="goToExternalClub('https://www.howtank.com/welcome?h=playbac_fr&v=feccbbe3cc9f11ed87c0065ac5de798caac148b')">
    <ion-icon slot="start" class="forum-pedagogique ion-text-center"></ion-icon>
   <ion-label>Forum Pédagogique</ion-label>
 </ion-item>
</ion-list>
<ion-list class="list" *ngIf="themeClass !== 'mquovideo' && themeClass !=='actuvideo' && themeClass !== 'clfy' ">
  <ion-item lines="none" class="ion-no-padding" (click)="goToExternal('https://www.playbacpresse.fr/abonnements-le-petit-quotidien?utm_source=NoelLPQ2017&utm_medium=LandingpageNoel&t=PBSI0455')">
    <ion-icon slot="start" class="boutique ion-text-center"></ion-icon>
    <span *ngIf="themeClass !== 'mwjp' && themeClass !== 'mwde' && themeClass !== 'clfy' && themeClass !== 'mljp' && themeClass !== 'mlde'">Boutique/Abonnez-vous!</span>
    <span *ngIf="themeClass === 'mwjp' || themeClass === 'mwde' || themeClass === 'clfy' || themeClass === 'mljp' || themeClass === 'mlde'">{{'MENU.ABONNEZ-VOUS' | translate}}</span>
  </ion-item>
</ion-list>
<ion-list class="list" *ngIf="themeClass === 'mquovideo'">
  <ion-item lines="none" class="ion-no-padding" (click)="goToExternal('https://www.playbacpresse.fr/abonnements-mon-quotidien-video?utm_source=LandingPageMenu_MQV&utm_medium=websitemenuMQV&utm_campaign=MQV_janvier2018&t=PBSI0475')">
    <ion-icon slot="start" class="boutique ion-text-center"></ion-icon>
    <ion-label>Abonnez-vous!</ion-label>
  </ion-item>
</ion-list>
<ion-list class="list" *ngIf="themeClass === 'actuvideo'">
  <ion-item lines="none" class="ion-no-padding" (click)="goToExternal('https://www.playbacpresse.fr/abonnements-l-actu-video?utm_source=LandingPagemenu_ACV&utm_medium=websitemenuACV&utm_campaign=ACV_janvier2018&t=PBSI0476')">
    <ion-icon slot="start" class="boutique ion-text-center"></ion-icon>
    <ion-label>Abonnez-vous!</ion-label>
  </ion-item>
</ion-list>
<ion-list class="list" *ngIf="isAuthenticated && accessLength && themeClass !== 'mwjp' && themeClass !== 'mwde' && themeClass !== 'clfy' && themeClass !== 'mljp' && themeClass !== 'mlde'">
  <ion-item lines="none" class="ion-no-padding">
    <ion-icon slot="start" class="journeaux ion-text-center"></ion-icon>
    <ion-label> Mes journaux</ion-label>
    <ion-icon slot="end" (click)="isOpen2 = !isOpen2" *ngIf="!isOpen2" class="arrowdownopen ion-item-right"></ion-icon>
    <ion-icon slot="end" (click)="isOpen2 = !isOpen2" *ngIf="isOpen2" class="arrowupclosed ion-item-right"></ion-icon>
  </ion-item>
  <div [ngClass]= "{'newspapers-container': true, 'closed': isOpen2}">
    <ion-item lines="none" class="ion-no-padding" *ngFor="let newspaperAccess of newspapersAccess" (click) = "filterArticles(newspaperAccess.subname)">
      <ion-label>{{newspaperAccess.name}}</ion-label>
    </ion-item>
  </div>
</ion-list>
<ion-list class="list" *ngIf="noAccessLength && themeClass !== 'mwjp' && themeClass !== 'mwde' && themeClass !== 'clfy' && themeClass !== 'mljp' && themeClass !== 'mlde' ">
  <ion-item lines="none" class="ion-no-padding">
    <ion-icon slot="start" class="journeaux ion-text-center"></ion-icon>
    <ion-label>Les autres journaux</ion-label>
    <ion-icon slot="end" (click)="isOpen = !isOpen" *ngIf="!isOpen" class="arrowdownopen ion-item-right"></ion-icon>
    <ion-icon slot="end" (click)="isOpen = !isOpen" *ngIf="isOpen" class="arrowupclosed ion-item-right"></ion-icon>
  </ion-item>
  <div [ngClass]= "{'newspapers-container': true, 'closed': isOpen}">
    <ion-item lines="none" class="ion-no-padding" *ngFor="let newspaperNoAccess of newspapersNoAccess" (click) = "openExternal(newspaperNoAccess.url)">
      <ion-label>{{newspaperNoAccess.name}}</ion-label>
    </ion-item>
  </div>
</ion-list>
<ion-list class="list last-list">
    <ion-item lines="none" class="border-top ion-no-padding" (click)="goStaticPage('nous-contacter')" *ngIf="themeClass !== 'mwjp' && themeClass !== 'mwde' && themeClass !== 'mljp' && themeClass !== 'mlde' && themeClass !== 'clfy' " [ngClass] = "themeClass">
      <ion-icon class="ion-text-center"></ion-icon>
      <ion-label>{{ 'MENU.NOUS_CONTACTER' | translate }}</ion-label>
    </ion-item>
    <ion-item lines="none" class="border-top ion-no-padding" (click)="badContent()" *ngIf="themeClass === 'mwjp' || themeClass === 'mwde' || themeClass === 'mljp' || themeClass === 'mlde' || themeClass === 'clfy'" [ngClass] = "themeClass">
      <ion-icon class="sampleicon ion-text-center"></ion-icon>
      <ion-label>{{ 'MENU.NOUS_CONTACTER' | translate }}</ion-label>
    </ion-item>
    <ion-item lines="none" class="ion-no-padding" (click)="goStaticPage(slugs.ouiSommesNous)" *ngIf="themeClass !== 'mwjp' && themeClass !== 'mljp' && themeClass !== 'mljp'">
      <ion-icon slot="start" class="sampleicon ion-text-center"></ion-icon>
      <ion-label>{{ 'MENU.QUI_SOMMES_NOUS' | translate }}</ion-label>
    </ion-item>
    <ion-item lines="none" class="ion-no-padding" (click)="goToExternalFAQ('https://www.playbacpresse.fr/page/faq')" *ngIf="themeClass !== 'mwjp' && themeClass !== 'mljp' && themeClass !== 'mwde' && themeClass !== 'mlde' ">
      <ion-icon slot="start" class="sampleicon ion-text-center"></ion-icon>
      <ion-label>F.A.Q.</ion-label>
    </ion-item>
    <ion-item lines="none" class="ion-no-padding" (click)="goStaticPage(slugs.mentionsLegales)">
      <ion-icon slot="start" class="sampleicon ion-text-center"></ion-icon>
      <ion-label>{{ 'MENU.LEGAL' | translate }}</ion-label>
    </ion-item>
    <ion-item lines="none" class="ion-no-padding" (click)="goStaticPage(slugs.viePrivee)">
      <ion-icon slot="start" class="sampleicon ion-text-center"></ion-icon>
      <ion-label>{{ 'MENU.VIE_PRIVEE' | translate }}</ion-label>
    </ion-item>
    <ion-item lines="none" class="ion-no-padding" (click)="goStaticPage(slugs.cookies)">
      <ion-icon slot="start" class="sampleicon ion-text-center"></ion-icon>
      <ion-label>{{ 'MENU.COOKIES' | translate }}</ion-label>
    </ion-item>
    <ion-item lines="none" class="ion-no-padding" (click)="goStaticPage(slugs['terms'])" *ngIf="themeClass === 'mlde'">
      <ion-icon slot="start" class="sampleicon ion-text-center"></ion-icon>
      <ion-label>{{ 'MENU.TERMS' | translate }}</ion-label>
    </ion-item>
    <ion-item lines="none" class="ion-no-padding">
      <ion-icon slot="start" class="sampleicon ion-text-center"></ion-icon>
      <ion-label>
        <a href="javascript:openAxeptioCookies()">{{ 'MENU.PARAMETRES_CONFIDENTIALITE' | translate }}</a>
      </ion-label>
    </ion-item>
    <ion-item lines="none" class="ion-no-padding" *ngIf="themeClass !== 'clfy' " (click)="goToExternal('https://www.playbacpresse.fr')">
        <ion-icon slot="start" class="sampleicon ion-text-center"></ion-icon>
        <ion-label>{{ 'MENU.FORMULE_ACCESS' | translate }}</ion-label>
    </ion-item>
    <ion-item lines="none" class="ion-no-padding" (click)="badContent()">
      <ion-icon slot="start" class="sampleicon ion-text-center"></ion-icon>
      <ion-label>{{ 'MENU.CONTENU_ILLICITE' | translate }}</ion-label>
    </ion-item>
</ion-list>
<p class="copyr ion-text-center">{{ 'MENU.TOUS_DROIDS_RESERVES' | translate }}</p>
<app-cookie-info></app-cookie-info>
</ion-content>
<ion-footer><app-bottom-menu [isActive]="isActivePage" (bottomNotify)="onBottomMenuNotify($event)"></app-bottom-menu></ion-footer>
<app-pop-up [show]="tempPopUp" [data]="popup" (popUpNotify)="onNotifyPopUp($event)"></app-pop-up>
